import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ToastModule} from './alert/toast.module';

@NgModule({
  imports: [
    CommonModule,
    ToastModule
  ],
  declarations: [],
  exports: [ToastModule]
})
export class DialogModule {
}
